<template>
  <div>

    <FilAriane :filArianeLabel="filArianeLabel" :filArianeMiddleLabel="filArianeMiddleLabel" :filArianeMiddleRouterLink="filArianeMiddleRouterLink"></FilAriane>

    <table
      style="font-family: verdana, arial, helvetica, sans-serif; font-size: 12px;"
      width="100%"
    >
      <tr>
        <td width="365">
          <b>
            Bienvenue,
            <span id="user-name">{{user.civility}} {{user.firstName}} {{user.lastName}}</span>
          </b>
        </td>
        <td width="260" align="center" v-if="displayCardPanel()">
          <label type="label" for="cardChange">Changement de carte</label>&nbsp;
          <select
            id="selectCard"
            v-model="selectedCardModel"
            @change="selectActualCard($event)"
          >
            <option
              v-for="card in $store.state.user.user.possibleCardsToSee"
              :key="card.cardNumberEncrypted"
              :value="card.cardNumberEncrypted"
            >{{ card.cardNumberEncrypted }}</option>
          </select>
        </td>
        <td width="260" align="center" v-else></td>
      </tr>
    </table>
    <table
      style="margin-bottom: 20px; font-family: verdana, arial, helvetica, sans-serif; font-size: 12px;"
      width="100%"
    >
      <tr>
        <td width="625" v-if="hasPermission(permissions, 'blocTopGlobal:displayEmail')">
          <a v-if="!user.emailPro && hasPermission(permissions, 'emailMaj:update')"
            class="linkModal"
            data-toggle="modal"
            data-target="#modalEmail"
            style="cursor: pointer; text-decoration: underline;"
          >Renseigner votre adresse mail professionnelle</a>
          <div v-else-if="!user.emailPro || user.emailPro == ''" style="display: flex;">
            <p style="padding-right: 5px;">
              Votre adresse email professionnelle n’est pas renseignée, merci de bien vouloir nous la communiquer.
            </p>
          </div>
          <div v-else-if="user.emailPro" style="display: flex;">
            <p style="padding-right: 5px;">
              {{user.emailPro}}
            </p>
            <a v-if="hasPermission(permissions, 'emailMaj:update')"
              class="linkModal"
              data-toggle="modal"
              data-target="#modalEmailModif"
              style="cursor: pointer; text-decoration: underline;"
            >Modifier</a>
          </div>
        </td>

        <td width="625" v-else />

        <td align="right" v-if="displayBtnImprimer">
          <div>
            <button @click="printRapport()" class="boutonG">
              <span>
                <span>
                  <span>Imprimer</span>
                </span>
              </span>
            </button>
          </div>
        </td>
      </tr>
      <tr>
        <td width="625" />
        <td align="right" v-if="hasPermission(permissions, 'internal')">
          <div>
            <a class="boutonG">
              <span>
                <span>
                  <span style="color: #0080ff" data-toggle="modal" data-target="#modalRunAs">Run as...</span>
                </span>
              </span>
            </a>
          </div>
        </td>
        <td align="right" v-else-if="!isRunAs && $store.state.user.isRunAsLaunched">
          <div>
            <button @click="releaseRunAs()" class="boutonG">
              <span>
                <span>
                  <span>Release Run as...</span>
                </span>
              </span>
            </button>
          </div>
        </td>
      </tr>
    </table>

    <div class="modal fade" id="modalEmail" role="dialog" style="padding-top: 100px;">
      <div class="modal-dialog">
        <div class="modal-content ui-widget-content">
          <div class="ui-widget-header" style="padding: 0.5em 0.2rem 0.5rem 1em;">
            Votre adresse mail
            <button
              type="button"
              class="close"
              style="color: white;padding-right: 10px;opacity: inherit;"
              data-dismiss="modal"
            >&times;</button>
          </div>
          <div class="modal-body">
            <table>
              <tbody>
                <tr>
                  <td style="padding-right: 10px;">Nouvelle adresse mail professionnelle</td>
                  <td colspan="2">
                    <input
                      :maxlength="70"
                      placeholder="xyz@exemple.fr"
                      id="nouveauMail"
                      name="nouveauMail"
                      type="text"
                      v-model="updateMailUser.mail"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="padding-right: 10px;">Confirmez votre nouvelle adresse mail</td>
                  <td colspan="2">
                    <input
                      :maxlength="70"
                      placeholder="xyz@exemple.fr"
                      id="nouveauMailConfimation"
                      name="nouveauMailConfimation"
                      type="text"
                      v-model="updateMailUser.confirmedMail"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="3"></td>
                </tr>
                <tr v-if="updateErrorMessage">
                  <td colspan="3" style="padding-right: 10px; color: red; font-weight: bold;">{{updateErrorMessage}}</td>
                </tr>
                <tr>
                  <td style="padding-top: 5px;" colspan="3" align="right">
                    <div style="float: right">
                      <a @click="updateMail('modalEmail')" class="boutonB" id="emailSubmit" style="cursor: pointer;">
                        <span>
                          <span>
                            <span>Valider</span>
                          </span>
                        </span>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalEmailModif" role="dialog" style="padding-top: 100px;">
      <div class="modal-dialog">
        <div class="modal-content ui-widget-content">
          <div class="ui-widget-header" style="padding: 0.5em 0.2rem 0.5rem 1em;">
            Votre adresse mail
            <button
              type="button"
              class="close"
              style="color: white;padding-right: 10px;opacity: inherit;"
              data-dismiss="modal"
            >&times;</button>
          </div>
          <div class="modal-body">
            <table>
              <tbody>
                <tr>
                  <td style="padding-right: 10px;">Ancienne adresse mail professionnelle</td>
                  <td colspan="2">
                    <input
                      :maxlength="70"
                      placeholder="xyz@exemple.fr"
                      id="oldMail"
                      name="oldMail"
                      type="text"
                      v-model="user.emailPro"
                      disabled
                    />
                  </td>
                </tr>
                <tr>
                  <td style="padding-right: 10px;">Nouvelle adresse mail professionnelle</td>
                  <td colspan="2">
                    <input
                     :maxlength="70"
                      placeholder="xyz@exemple.fr"
                      id="nouveauMailPro"
                      name="nouveauMailPro"
                      type="text"
                      v-model="updateMailUser.mail"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="padding-right: 10px;">Confirmez votre nouvelle adresse mail</td>
                  <td colspan="2">
                    <input
                      :maxlength="70"
                      placeholder="xyz@exemple.fr"
                      id="nouveauMailProConfimation"
                      name="nouveauMailProConfimation"
                      type="text"
                      v-model="updateMailUser.confirmedMail"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="3"></td>
                </tr>
                <tr v-if="updateErrorMessage">
                  <td colspan="3" style="padding-right: 10px; color: red; font-weight: bold;">{{updateErrorMessage}}</td>
                </tr>
                <tr>
                  <td style="padding-top: 5px;" colspan="3" align="right">
                    <div style="float: right">
                      <a @click="updateMail('modalEmailModif')" class="boutonB" id="emailSubmit" style="cursor: pointer;">
                        <span>
                          <span>
                            <span>Valider</span>
                          </span>
                        </span>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalRunAs" role="dialog" style="padding-top: 100px;">
      <div class="modal-dialog">
        <div class="modal-content ui-widget-content">
          <div class="ui-widget-header" style="padding: 0.5em 0.2rem 0.5rem 1em;">
            Se logger en tant que...
            <button
              type="button"
              class="close"
              style="color: white;padding-right: 10px;opacity: inherit;"
              data-dismiss="modal"
            >&times;</button>
          </div>
          <div class="modal-body">
            <table>
              <tbody>
                <tr>
                  <td style="padding-right: 10px;">Login</td>
                  <td colspan="2">
                    <input
                      id="username"
                      maxlength="20"
                      tabindex="1"
                      autocomplete="off"
                      v-model="userRunAs.login"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="3"></td>
                </tr>
                <tr>
                  <td style="padding-top: 5px;" colspan="3" align="right">
                    <button class="boutonB" @click="loginAs()">
                      <span>
                        <span>
                          <span>Valider</span>
                        </span>
                      </span>
                    </button>
                  </td>
                </tr>
                <tr v-if="errorMessageRunAs">
                  <td style="color: red; font-size: 12px; padding-top: 5px;" colspan="3" align="right">
                    {{ errorMessageRunAs }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hasPermission from '@/utils/utils.js'
import { User, UpdateMailUser } from '@/models/user.model'
import { ImpressionRapport } from '@/models/impression.model'
import FilAriane from '@/components/FilAriane.vue'

import $ from 'jquery'

export default {
  components: {
    FilAriane
  },
  data: function () {
    return {
      errorMessageRunAs: null,
      userRunAs: new User(),
      user: this.$store.state.user.user,
      permissions: this.$store.state.user.user
        ? this.$store.state.user.user.permissions
        : [],
      hasPermission,
      isRunAs: false,
      displayBtnImprimer: false,
      impressionBean: new ImpressionRapport(),
      pagesNamesForCardPanel: [
        'porteur/depensescarte',
        'porteur/detailcarte',
        'porteur/releveoperation',
        'porteur/DDDSecure'
      ],
      selectedCardModel: this.$store.state.user.actualSelectedCard
        ? this.$store.state.user.actualSelectedCard.cardNumberEncrypted
        : '',
      updateMailUser: new UpdateMailUser(),
      updateErrorMessage: '',
      filArianeLabel: this.$store.state.filArianePage,
      filArianeMiddleLabel: this.$store.state.filArianeMiddlePage ? this.$store.state.filArianeMiddlePage : null,
      filArianeMiddleRouterLink: this.$store.state.filArianeMiddleRouterLink ? this.$store.state.filArianeMiddleRouterLink : null
    }
  },
  methods: {
    loginAs () {
      this.errorMessageRunAs = null
      this.$store.dispatch('user/selectUserToReturn', this.$store.state.user.user.login)
      this.$store.dispatch('user/loginAs', this.userRunAs).then(
        (response) => {
          this.isRunAs = true
          if (this.$route.name === response.firstPageUrl.toLowerCase()) {
            location.reload()
          } else {
            this.$router.push({ name: response.firstPageUrl.toLowerCase() })
          }
          $('#modalRunAs').modal('hide')
        },
        () => {
          this.isRunAs = false
          this.errorMessageRunAs = 'Impossible d\'effectuer le runAs sur ce user (conf xarm)'
        }
      )
    },
    releaseRunAs () {
      if (this.$store.state.user.loginToReturn) {
        this.$store.dispatch('user/releaseRunAs', this.$store.state.user.loginToReturn).then(
          (response) => {
            this.isRunAs = false
            if (this.$route.name === response.firstPageUrl.toLowerCase()) {
              location.reload()
            } else {
              this.$router.push({ name: this.$store.state.user.user.firstPageUrl })
            }
          },
          (error) => {
            this.isRunAs = false
            this.errorMessage = error.response
          }
        )
      }
    },
    displayCardPanel () {
      if (this.$store.state.user.user && this.$store.state.user.user.groupe &&
        (this.$store.state.user.user.groupe.name === 'Porteur' ||
          this.$store.state.user.user.groupe.name === 'DemoPorteur') &&
        this.pagesNamesForCardPanel.includes(this.$route.name)
      ) {
        return true
      }
      return false
    },
    selectActualCard (event) {
      this.$store.state.user.user.possibleCardsToSee.forEach((theCard, index) => {
        if (theCard.cardNumberEncrypted === event.target.value) {
          this.$store.dispatch('user/selectActualCard', theCard)
          this.$emit('updateSelectedCard', index)
        }
      })
    },
    updateMail (modalId) {
      if (this.updateMailUser.mail === '' || this.updateMailUser.confirmedMail === '') {
        this.updateErrorMessage = 'Merci de renseigner tous les champs du formulaire'
      } else if (this.$store.state.user.user.emailPro === this.updateMailUser.mail && this.$store.state.user.user.emailPro === this.updateMailUser.confirmedMail) {
        this.updateErrorMessage = "L'adresse mail saisie est identique à l'ancienne"
      } else if (this.updateMailUser.mail === this.updateMailUser.confirmedMail) {
        this.updateMailUser.login = this.$store.state.user.user.login
        this.updateMailUser.personneId = this.$store.state.user.user.personneId
        this.updateMailUser.oldMail = this.$store.state.user.user.emailPro
        this.$store.dispatch('user/updateMail', this.updateMailUser).then(
          (response) => {
            this.updateMailUser.mail = ''
            this.updateMailUser.confirmedMail = ''
            $('#' + modalId).modal('hide')
          },
          (error) => {
            this.updateErrorMessage = error.response
          }
        )
      } else {
        this.updateErrorMessage = 'Les deux adresses mail renseignées ne correspondent pas'
      }
    },
    printRapport () {
      if (this.displayBtnImprimer) {
        if (this.$store.state.user.actualSelectedCard) {
          this.impressionBean.selectedCardId = this.$store.state.user.actualSelectedCard.cardId
          this.impressionBean.selectedPorteurId = this.$store.state.user.actualSelectedCard.contract.personne.personneId
        } else if (this.$store.state.entreprise.editedCarte) {
          this.impressionBean.selectedCardId = this.$store.state.entreprise.editedCarte.cardId
          this.impressionBean.selectedPorteurId = this.$store.state.entreprise.editedCarte.contract.personne.personneId
        }

        this.impressionBean.pageName = this.$router.currentRoute.name
        this.impressionBean.selectedPeriode = this.$store.state.user.user.selectedPeriode ? this.$store.state.user.user.selectedPeriode.periodeId : null
        this.impressionBean.selectedEntreprise = this.$store.state.user.user.selectedEntreprise ? this.$store.state.user.user.selectedEntreprise : null
        this.impressionBean.loggedUserLogin = this.$store.state.user.user.login
        this.impressionBean.adminRechercheOperationsParameters = this.$store.state.entreprise.rechercheOperation

        // En profil porteur, la periode et l'echeance sont dans le store cote porteur
        if (this.$store.state.porteur && this.$store.state.porteur.editedPeriode != null) {
          this.impressionBean.selectedPeriode = this.$store.state.porteur.editedPeriode.periodeId
        }
        if (this.$store.state.porteur && this.$store.state.porteur.editedEcheance != null) {
          this.impressionBean.selectedPorteurId = this.$store.state.porteur.editedEcheance.personneId
          this.impressionBean.selectedCardId = this.$store.state.porteur.editedEcheance.cardId
        }

        // En profil porteur, la periode et l'echeance sont dans le store cote porteur
        if (this.$store.state.porteur && this.$store.state.porteur.editedPeriode != null) {
          this.impressionBean.selectedPeriode = this.$store.state.porteur.editedPeriode.periodeId
        }
        if (this.$store.state.porteur && this.$store.state.porteur.editedEcheance != null) {
          this.impressionBean.selectedPorteurId = this.$store.state.porteur.editedEcheance.personneId
          this.impressionBean.selectedCardId = this.$store.state.porteur.editedEcheance.cardId
        }

        this.$store.dispatch('user/printDoc', this.impressionBean).then(
          (response) => {
            if ('msSaveOrOpenBlob' in navigator) {
              window.navigator.msSaveOrOpenBlob(new Blob([response], { type: 'application/pdf' }), this.getOutputFileName())
            } else {
              let blob = new Blob([response], { type: 'application/pdf' })
              var hiddenElement = document.createElement('a')
              hiddenElement.href = URL.createObjectURL(blob)
              hiddenElement.target = '_blank'
              hiddenElement.download = this.getOutputFileName()
              document.body.appendChild(hiddenElement)
              hiddenElement.click()
              document.body.removeChild(hiddenElement)
            }
          },
          (error) => {
            this.isRunAs = false
            this.errorMessage = error.response
          }
        )
      }
    },
    getOutputFileName () {
      switch (this.$router.currentRoute.name) {
        case 'porteur/depensescarte':
          return new Date().getTime() + ' Dépenses porteur.pdf'
        case 'porteur/operationscarte':
          return new Date().getTime() + ' Opérations porteur.pdf'
        case 'entreprise/gestionnairedepenses':
          return new Date().getTime() + ' Dépenses entreprise.pdf'
        case 'entreprise/gestionnaireoperations':
          return new Date().getTime() + ' Dépenses entreprise - Opérations.pdf'
        case 'entreprise/gestionnaireparcdecartesdetail':
          return new Date().getTime() + ' Parc de cartes - Detail.pdf'
        case 'entreprise/gestionnaireparcdecartes':
          return new Date().getTime() + ' Parc de cartes.pdf'
        case 'administration/adminrechercheoperations':
          return new Date().getTime() + ' Recherche opérations.pdf'
      }
    }
  },
  mounted () {
    this.$store.dispatch('user/selectActualCard', this.$store.state.user.user.possibleCardsToSee && this.$store.state.user.user.possibleCardsToSee.length ? this.$store.state.user.user.possibleCardsToSee[0] : '')

    if (!this.selectedCardModel) {
      this.selectedCardModel = this.$store.state.user.actualSelectedCard.cardNumberEncrypted
    }

    let listePagesBoutonImprimer = ['porteur/depensescarte', 'porteur/depensescarte', 'porteur/operationscarte',
      'entreprise/gestionnairedepenses', 'entreprise/gestionnaireoperations', 'entreprise/gestionnaireparcdecartes',
      'entreprise/gestionnaireparcdecartesdetail', 'administration/adminrechercheoperations']

    if (!String.prototype.includes) {
      if (listePagesBoutonImprimer.indexOf(this.$router.currentRoute.name, 0) !== -1) {
        this.displayBtnImprimer = true
      }
    } else {
      if (listePagesBoutonImprimer.includes(this.$router.currentRoute.name)) {
        this.displayBtnImprimer = true
      }
    }

    if (!this.$store.state.user.user.selectedEntreprise && !this.$store.state.user.user.entrepriseId) {
      this.displayBtnImprimer = false
    }
  }
}
</script>

<style lang="scss">
a.boutonG,
button.boutonG {
  background: none repeat scroll 0 0 transparent;
  border: 0 none;
  cursor: pointer;
  display: inline-block;
  font: 11px/1.5 Trebuchet MS, Arial, Helvetica, sans-serif;
  color: #0080ff;
  margin: 0;
  padding: 0;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  border-collapse: separate;
}

a.boutonG span,
button.boutonG span {
  background: url("../assets/bouton_gris_gauche_na.png") no-repeat scroll left
    top transparent;
  float: left;
  padding: 0 0 0 17px;
  position: relative;
  vertical-align: middle;
}
a.boutonG span span,
button.boutonG span span {
  background: url("../assets/bouton_gris_droit_na.png") no-repeat scroll right
    top transparent;
  padding: 0 17px 0 0;
}
a.boutonG span span span,
button.boutonG span span span {
  background: url("../assets/bouton_gris_milieu_na.png") repeat-x scroll left
    top transparent;
  height: 18px;
  line-height: 1.6;
  padding: 0;
}
a.boutonG:hover span,
button.boutonG:hover span {
  background: url("../assets/bouton_gris_gauche_a.png") no-repeat scroll left
    top transparent;
  float: left;
  padding: 0 0 0 17px;
  position: relative;
  vertical-align: middle;
}
a.boutonG:hover span span,
button.boutonG:hover span span {
  background: url("../assets/bouton_gris_droit_a.png") no-repeat scroll right
    top transparent;
  padding: 0 17px 0 0;
}
a.boutonG:hover span span span,
button.boutonG:hover span span span {
  background: url("../assets/bouton_gris_milieu_a.png") repeat-x scroll left top
    transparent;
  height: 18px;
  line-height: 1.6;
  padding: 0;
  text-decoration: underline;
}

.linkModal {
  color: black;
  text-decoration: underline;
  font-weight: 100;
}

.ui-widget-header {
  background-color: #a5ce54;
  background-image: none;
  border: 1px solid #a5ce54;
  color: #ffffff;
  font-weight: bold;
  font-size: 2em;
}
.ui-widget-content {
  border: 2px solid #a5ce54 !important;
  color: #333333 !important;
  border-radius: 4px !important;
}
.boutonB {
  border: 0;
  background: white;
}
</style>
